import { create } from "zustand";
import axios from "axios";

const seriesStore = create((set, get) => ({
    series: null,

    seriesForm: {
        title: "",
        overview: "",
        network: "",
        year: "",
        originalCountry: "",
        originalLanguage: "",
        numberOfSeasons: "",
        airingStatus: "",
        whereToWatch: "",
        tvdbId: "",
        genres: [],
        poster: "",
        fanart: "",
        score: "",
    },

    fetchSeries: async () => {
        // Fetch the series
        const res = await axios.get("/series");

        // Set to state
        set({ series: res.data.series });
    },

    tvdbSearchSeries: async (query) => {
        const res = await axios.get("/api/search", {
            params: { query }
        });

        console.log("Runnign tvdbSearchSeries ", res.data.data?.[0]);

        return res.data.data?.[0];  
    },

    tvdbGetSeries: async (seriesId) => {
        const res = await axios.get(`/api/series/${seriesId}`);

        console.log("Runnign tvdbGetSeries ", res.data);
        return res.data;
    },

    populateForm1: (data) => {
        try {
            set(state => ({
                seriesForm: {
                    ...state.seriesForm,
                    title: data.name || "",
                    overview: data.overview || "",
                    network: data.network || "",
                    year: data.year || "",
                    originalCountry: data.country || "",
                    originalLanguage: data.primary_language || "",
                    airingStatus: data.status || "",
                    tvdbId: data.tvdb_id || "",
                    
                }
            }));
        } catch (err) {
            console.log("Error at populateForm1");
        }
    },

    populateForm2: (data) => {
        try {
            set(state => ({
                seriesForm: {
                    ...state.seriesForm,
                    numberOfSeasons: data.season || "", 
                    genres: data.genre || [],
                    poster: "https://artworks.thetvdb.com/banners/" + data.poster || "",
                    fanart: "https://artworks.thetvdb.com/banners/" + data.fanart || "",
                    score: data.siteRatingCount || "", //this may need to be changed
                }
            }));
        } catch (err) {
            console.log("Error at populateForm2");
        }
    },


    updateSeriesForm: (e) => {
        try {
            const { name, value } = e.target;

            set(state => {
                return {
                    seriesForm: {
                    ...state.seriesForm,
                    [name]: value,
                    },
                };
            });
        } catch (err) {
            console.log("Error at updateSeriesForm");
        }
    },

    createSeries: async (e) => {
        try {
            const { seriesForm } = seriesStore.getState();
            const res = await axios.post("/series", seriesForm);

            // Clear the form fields
            set({
                seriesForm: {
                    title: "",
                    overview: "",
                    network: "",
                    year: "",
                    originalCountry: "",
                    originalLanguage: "",
                    numberOfSeasons: "",
                    airingStatus: "",
                    whereToWatch: "",
                    tvdbId: "",
                    genres: [],
                    poster: "",
                    fanart: "",
                    score: "",
                },
            });

            return res;
        } catch (err) {
            console.log("Error at createSeries");
        }
    },

    updateSeries: async (seriesId) => {
        try {
            const { seriesForm } = seriesStore.getState();
            console.log("Update series running. Score is ", seriesForm.score);
            const res = await axios.put(`/series/${seriesId}`, {seriesId: seriesId, seriesForm: seriesForm});

            // Clear the form fields
            set({
                seriesForm: {
                    title: "",
                    overview: "",
                    network: "",
                    year: "",
                    originalCountry: "",
                    originalLanguage: "",
                    numberOfSeasons: "",
                    airingStatus: "",
                    whereToWatch: "",
                    tvdbId: "",
                    genres: [],
                    poster: "",
                    fanart: "",
                    score: "",
                },
            });
        } catch (err) {
            console.log("Error at updateSeries");
        }
    },
}));

export default seriesStore;